import { render, staticRenderFns } from "./ClinicAdmin.vue?vue&type=template&id=061c6df0"
import script from "./ClinicAdmin.vue?vue&type=script&lang=js"
export * from "./ClinicAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports